import React, { useEffect } from 'react';

const TermsAndConditions = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://cdn.iubenda.com/iubenda.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <React.Fragment>
      <a
        href="https://www.iubenda.com/terms-and-conditions/16278720"
        title="Terms and Conditions"
        className="iubenda-black iubenda-noiframe iubenda-embed iubenda-noiframe policy"
      >
        Terms and Conditions
      </a>
    </React.Fragment>
  );
};

export default TermsAndConditions;
